import React from "react";


import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
import MDAvatar from "components/MDAvatar";
import { Box } from '@mui/material';
import { Alert } from '@mui/material';

// core components
import { useQuery } from "react-query";
import helmImage from "assets/img/helm.png";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";

import axios from "axios";

export default function HelmTable(props) {
  const url = "/api/v1/k8s/helms";
  const [token, setToken] = useToken();
  useAxiosAuth(token);
  const HelmName = ({ image, name }) => (
      <MDAvatar src={image} name={name} size="sm" />
  );
  const columns = [
    { Header: "", accessor: "icon", width: "1px" },
    { Header: "name", accessor: "name", width: "30%", align: "left" },
    { Header: "namespace", accessor: "namespace", align: "left" },
    { Header: "version", accessor: "version", align: "center" },
    { Header: "modified", accessor: "modified", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
  ];

  const { isLoading, error, data } = useQuery(
    "helm", () => axios.get(
      url,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => (res.hasOwnProperty('data') && res.data.hasOwnProperty('data'))? res.data.data : null
    )
  )

  const helmData = (data) => {
    let tableData = {
      columns: columns,
      rows: []
    };
    if (data) {
      if ("items" in data) {
        tableData.rows = data.items.map((item) => {
            const name = (item.name) ? item.name : ""
            return {
              icon: <HelmName image={helmImage} name={name} />,
              name: name,
              namespace: (item.namespace) ? item.namespace : "",
              version: (item.version) ? item.version : "",
              modified: (item.modified_at) ? new Date(item.modified_at*1000).toISOString() : "",
              status: (item.status) ? item.status : ""
            }
          }
        )
      }
    }

    return tableData;
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }
      {(isLoading && !error) && <CircularProgress size={30} style={{marginLeft: '45%', position: 'absolute',  top : '30%' ,  zIndex: '1'}}/> }
      {(!isLoading && !error) && 
      <DataTable
        table={ helmData(data) }
        canSearch={true}
        showTotalEntries={true}
        isSorted={true}
        noEndBorder
        entriesPerPage={true}
      />
      }
    </React.Fragment>
  );
}
